/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const VersionStatusDto = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Retired: 'RETIRED'
} as const;

export type VersionStatusDto = typeof VersionStatusDto[keyof typeof VersionStatusDto];



